export const DownloadIcon = () => (
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="22" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
  </svg>
);
